import React from 'react';
import Dropzone from 'react-dropzone';
//import { Col } from 'react-bootstrap';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';

import { sortBy } from 'lodash';

import { onFileDrop, onFileDelete } from './onFileModify';

import getSort from '../commonJS/getSort';

/*
  使用FileDropAreaCt時，upload files由它管控，
  download files 由父元件管控。
  upload files需在父元件定義一個儲存上傳資料的陣列(不用state)
  並以uploadedFiles的prop name傳入，以進行新增/刪除處理。

  download files父元件使用共用的onFileModify funcs進行下載登錄
  以及刪除控制，父元件需定義對應的states。

  其他全在FileDropAreaCt內部處理，檔案類型過濾，轉換成預覽元素等等，
  以獨立元件，不將資料存在內部是為了不讓相同資料重複儲存在兩個元件
  內部只存分類資料，用以在適當的時機(onDrop時)更新預覽圖
  若由外部傳入分類資料，則無法只有必要的時機更新，
  而是每次render都要map一次
*/

// 排序功能:
// 在container(例如ProductModalCt)新增img、pdf、video sort arr，
// 以及觸發更新用的forceUpdate
// 在onFileDrop, onFileDelete中從arr新增、移除異動項目id
// 在FilePreviewPs中依arr做render前排序
// 在dnd事件中更新id排序

const FilePreviewPs = props => {
  // 性能考量，應該改成只在需要時重排序
  let arrImg = props.previewsImg.concat(props.previewsImgDL),
    arrPDF = props.previewsPDF.concat(props.previewsPDFDL),
    arrVideo = props.previewsVideo.concat(props.previewsVideoDL);

  if (props.fileSorts) {
    arrImg = sortBy(arrImg, [o => getSort(props.fileSorts.img, o.props.fileName)]);
    arrPDF = sortBy(arrPDF, [o => getSort(props.fileSorts.pdf, o.props.fileName)]);
    arrVideo = sortBy(arrVideo, [o => getSort(props.fileSorts.video, o.props.fileName)]);
  }

  return (
    <div className="div-file-preview-area-container">
      {
        (props.previewsImg.length || props.previewsImgDL.length) ?
          <div className="div-file-preview-img">
            <div>Image</div>
            {/*props.previewsImg*/}
            {/*props.previewsImgDL*/}
            {arrImg}
          </div>
          :
          ""
      }

      {
        (props.previewsPDF.length || props.previewsPDFDL.length) ?
          <div className="div-file-preview-pdf">
            <div>PDF</div>
            {arrPDF}
          </div>
          :
          ""
      }

      {
        (props.previewsVideo.length || props.previewsVideoDL.length) ?
          <div className="div-file-preview-video">
            <div>Video</div>
            {arrVideo}
          </div>
          :
          ""
      }

    </div>

  );
}

class FileDropAreaCtBase extends React.Component {
  constructor(props) {
    super(props);

    this.onDrop = (accpetedFiles, rejectedFiles) => {
      if (this.props.disabled) return;
      onFileDrop(accpetedFiles, rejectedFiles, this, false, this.props.singleFileLimit, this.props.enableDnd, this.props.fileSorts, this.props.parentStateHandler, this.props.containerThis);
    };

    this.onFileDelete = (type, fileName) => {
      if (this.props.disabled) return;
      onFileDelete(type, fileName, this, false, this.props.fileSorts);
    };

    this.acceptFormats = 'image/jpeg, image/png, image/svg+xml, video/mp4, application/pdf';

    this.state = {
      uploadedImgs: [],
      uploadedPDFs: [],
      uploadedVideos: [],
      previewsImg: [],
      previewsPDF: [],
      previewsVideo: []
    };

  }

  static propTypes = {
    uploadedFiles: React.PropTypes.array.isRequired
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.clearUploadedFileLocal) {

      this.setState({
        uploadedImgs: [],
        uploadedPDFs: [],
        uploadedVideos: [],
        previewsImg: [],
        previewsPDF: [],
        previewsVideo: []
      });

      this.props.parentStateHandler({
        states: 'clearUploadedFileLocal', newValues: false
      });
    }
  }

  render() {

    const { languageData, languageCode } = window.myConsts;

    const showPreviews = (
      this.state.previewsImg.length > 0 ||
      this.state.previewsPDF.length > 0 ||
      this.state.previewsVideo.length > 0 ||
      this.props.downloadedFilesPreview.previewsImg.length > 0 ||
      this.props.downloadedFilesPreview.previewsPDF.length > 0 ||
      this.props.downloadedFilesPreview.previewsVideo.length > 0
    );

    let disableClick = this.props.disabled;
    // for single file limit
    // 如果限制單一檔案，則舊檔案必須先"本地"移除後才能"本地"上傳
    // 最後才透過api實際移除舊檔與新增新檔
    // 若本來上傳狀態就是disable的就無需調整
    if (!disableClick) {
      // 如果本來是可上傳的但有限制單檔，在有既存preview的情況下不開放上傳
      // 需先移除既有檔案
      if (this.props.singleFileLimit && showPreviews) disableClick = true;
    }

    return (
      <Dropzone
        onDrop={this.onDrop}
        multiple={this.props.multiple && true}
        className={disableClick === true ? "cust-file-dropzone disabled" : "cust-file-dropzone"}
        activeClassName="cust-file-dropzone-active"
        accept={this.props.accept || this.acceptFormats}
        disableClick={disableClick}
        preventDropOnDocument={true}
        disablePreview={this.props.disablePreview || false}
      >

        {
          showPreviews ?
            <FilePreviewPs
              fileSorts={this.props.fileSorts}
              previewsImg={this.state.previewsImg}
              previewsPDF={this.state.previewsPDF}
              previewsVideo={this.state.previewsVideo}
              previewsImgDL={this.props.downloadedFilesPreview.previewsImg}
              previewsPDFDL={this.props.downloadedFilesPreview.previewsPDF}
              previewsVideoDL={this.props.downloadedFilesPreview.previewsVideo} />
            :
            <div style={this.props.placeholderStyle} className="div-file-drop-zone-placeholder">
              {this.props.defaultText || languageData['439'][languageCode] /*請拖拉檔案至此區域，或點擊後選擇檔案。*/}
            </div>
        }

      </Dropzone>
    );
  }
}

export const FileDropAreaCt = DragDropContext(HTML5Backend)(FileDropAreaCtBase);




// 以下mirror建立

//For任何格式的檔案上傳
export class FileDropAreaAnyFileCt extends React.Component {
  render() {
    let files = "";
    let {
      uploadedFiles,
      onDrop,
      onPreviewFileDelete
    } = this.props;
    if (uploadedFiles.length) {
      files = uploadedFiles.map((file, index) => {
        // let fileName = index+1 + '. ' + file.name;
        let preview_render = ''
        let file_type = file.type.split('/')

        if (file_type[0] === 'image') {

          preview_render = <div className="preview_img"><img src={file.preview} alt='img preview' /></div>
        }
        else if (file_type[0] === 'video') {

          preview_render = <div className="preview_video"><video controls><source src={file.preview} type="video/mp4" /></video></div>
        }
        else if (file_type[1] === 'pdf') {

          preview_render = <div className="preview_pdf"><embed src={file.preview} /></div>
        }

        return (
          <figure key={index} onClick={(e) => e.stopPropagation()}>
            {preview_render}
            <div className="file_name">{file.name}</div>
            <span className="glyphicon glyphicon-remove-circle" onClick={() => onPreviewFileDelete(file.name)}></span>
          </figure>
        );
      });
    }

    return (
      <Dropzone onDrop={onDrop} className="news-file-dropzone row file-dropzone">
        {files || <div className="onClickToUpload">請點選此處上傳檔案</div>}
      </Dropzone>
    );
  }
}


// WEBPACK FOOTER //
// ./src/commonComponents/FileDropAreaCt.jsx